"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[793],{

/***/ 5997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Features; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/section-title.jsx
var section_title = __webpack_require__(5715);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.mjs
var io5 = __webpack_require__(8318);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(1355);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 18 modules
var dialog = __webpack_require__(4821);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/modal.jsx




var Modal = function(param) {
    var content = param.content, isOpen = param.isOpen, setIsOpen = param.setIsOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
        appear: true,
        show: isOpen,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
            as: "div",
            className: "relative z-50",
            onClose: function() {
                return setIsOpen(false);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 bg-black bg-opacity-80"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 overflow-y-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex min-h-full items-center justify-center p-4 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 scale-95",
                            enterTo: "opacity-100 scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 scale-100",
                            leaveTo: "opacity-0 scale-95",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                                className: "modal w-full max-w-screen-xl transform overflow-visible bg-white rounded-2xl bg-transaparent p-0 text-left align-middle shadow-xl transition-all",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "absolute left-auto top-2 right-2 text-3xl",
                                        onClick: function() {
                                            return setIsOpen(false);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5/* IoCloseOutline */.IOM, {
                                            "arial-label": "Close modal"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "p-8 lg:p-16",
                                        dangerouslySetInnerHTML: {
                                            __html: content
                                        }
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var modal = (Modal);

;// CONCATENATED MODULE: ./components/feature.jsx





function Feature(param) {
    var feature = param.feature, featureListCss = param.featureListCss, featureCss = param.featureCss, featureTitleCss = param.featureTitleCss, featureContentCss = param.featureContentCss, titleTag = param.titleTag;
    titleTag = titleTag ? titleTag : "h3";
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex feature-item gap-4 mb-4 ".concat(featureCss ? featureCss : ""),
        children: [
            feature.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "flex flaticon-".concat(feature.icon.icon, " text-").concat(feature.icon.style, " text-6xl ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col feature-item-wrapper",
                children: [
                    titleTag === "h3" && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "block ".concat(featureTitleCss ? featureTitleCss : ""),
                        children: feature.title
                    }),
                    titleTag === "strong" && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        className: "block text-trust-500 ".concat(featureTitleCss ? featureTitleCss : ""),
                        children: feature.title
                    }),
                    titleTag === "p" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "block text-trust-500 font-semibold ".concat(featureTitleCss ? featureTitleCss : ""),
                        children: feature.title
                    }),
                    titleTag === "span" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "block text-trust-500 font-semibold ".concat(featureTitleCss ? featureTitleCss : ""),
                        children: feature.title
                    }),
                    feature.content && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "block feature-content mb-4 ".concat(featureContentCss ? featureContentCss : ""),
                        dangerouslySetInnerHTML: {
                            __html: feature.content
                        }
                    }),
                    feature.expandableContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                onClick: function() {
                                    return setIsOpen(true);
                                },
                                className: "btn action-border block mx-auto",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(io5/* IoChevronForward */.mzm, {
                                        className: "inline-block"
                                    }),
                                    feature.expandButtonLabel ? feature.expandButtonLabel : "Read more"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal, {
                                content: feature.expandableContent,
                                isOpen: isOpen,
                                setIsOpen: setIsOpen
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/features-grid.jsx



function FeaturesGrid(param) {
    var features = param.features, title = param.title, description = param.description, featureTitleCss = param.featureTitleCss, featureContentCss = param.featureContentCss, featureCss = param.featureCss, titleTag = param.titleTag;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (title || description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(section_title/* default */.Z, {
                title: title,
                description: description,
                className: "w-full mt-20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid gap-2 grid-cols-1 md:grid-cols-3 px-10 md:mt-10",
                children: features.map(function(f) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
                        feature: f,
                        featureCss: featureCss,
                        featureTitleCss: featureTitleCss,
                        featureContentCss: featureContentCss,
                        titleTag: titleTag
                    }, f.id);
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/features-grid-light.jsx


function FeaturesGridLight(param) {
    var features = param.features, title = param.title, description = param.description, featureTitleCss = param.featureTitleCss, featureContentCss = param.featureContentCss, featureCss = param.featureCss, _titleTag = param.titleTag, titleTag = _titleTag === void 0 ? "h3" : _titleTag;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (title || description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(section_title/* default */.Z, {
                title: title,
                description: description,
                className: "w-full lg:w-2/3 mt-20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 p-10 md:pb-0 gap-10 w-full ml-auto text-center ",
                children: features.map(function(entry) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pt-0 flex flex-col items-center ".concat(featureCss !== null && featureCss !== void 0 ? featureCss : featureCss),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "flex flaticon-".concat(entry.icon.icon, " text-").concat(entry.icon.style, " text-6xl ")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col pt-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "font-normal text-opacity-100 block ".concat(featureTitleCss ? featureTitleCss : ""),
                                        children: entry.title
                                    }),
                                    entry.content && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "block mb-4 opacity-50 ".concat(featureContentCss !== null && featureContentCss !== void 0 ? featureContentCss : featureContentCss),
                                        dangerouslySetInnerHTML: {
                                            __html: entry.content
                                        }
                                    })
                                ]
                            })
                        ]
                    }, entry.id.toString());
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/features-one-column.jsx



function FeaturesOneColumn(param) {
    var features = param.features, title = param.title, description = param.description, featureTitleCss = param.featureTitleCss, featureContentCss = param.featureContentCss, featureCss = param.featureCss, titleTag = param.titleTag;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col md:flex-row mt-20 f-onecolumn",
        children: [
            (title || description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(section_title/* default */.Z, {
                className: "flex w-full md:w-1/2 pb-8",
                title: title,
                description: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex w-full flex-col md:w-1/2 px-10 ",
                children: features.map(function(f) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
                        feature: f,
                        featureCss: featureCss,
                        featureTitleCss: featureTitleCss,
                        featureContentCss: featureContentCss,
                        titleTag: titleTag
                    }, f.id);
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/features-two-columns.jsx



function FeaturesTwoColumns(param) {
    var features = param.features, title = param.title, description = param.description, featureListTitleCss = param.featureListTitleCss, featureTitleCss = param.featureTitleCss, featureContentCss = param.featureContentCss, featureCss = param.featureCss, titleTag = param.titleTag;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (title || description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(section_title/* default */.Z, {
                title: title,
                description: description,
                className: "w-full mt-10 section-title ".concat(featureListTitleCss)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid gap-10 grid-cols-1 md:grid-cols-2 px-10 md:mt-10",
                children: features.map(function(f) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
                        feature: f,
                        featureCss: featureCss,
                        featureTitleCss: featureTitleCss,
                        featureContentCss: featureContentCss,
                        titleTag: titleTag
                    }, f.id);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-motion-value.mjs
var use_motion_value = __webpack_require__(4960);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-transform.mjs + 3 modules
var use_transform = __webpack_require__(8828);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 173 modules
var motion = __webpack_require__(390);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 5 modules
var AnimatePresence = __webpack_require__(1526);
;// CONCATENATED MODULE: ./components/hover-effect.jsx



var HoverEffect = function(param) {
    var children = param.children;
    var containerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isHovered = ref[0], setIsHovered = ref[1];
    var x = (0,use_motion_value/* useMotionValue */.c)(0);
    var y = (0,use_motion_value/* useMotionValue */.c)(0);
    var initialX = (0,use_motion_value/* useMotionValue */.c)(0);
    var initialY = (0,use_motion_value/* useMotionValue */.c)(0);
    var rotateX = (0,use_transform/* useTransform */.H)(isHovered ? y : initialY, [
        -50,
        50
    ], [
        "-15deg",
        "15deg"
    ], {
        clamp: false
    });
    var rotateY = (0,use_transform/* useTransform */.H)(isHovered ? x : initialX, [
        -50,
        50
    ], [
        "15deg",
        "-15deg"
    ], {
        clamp: false
    });
    var handleMouseMove = function(event) {
        var container = containerRef.current;
        if (container) {
            var ref = container.getBoundingClientRect(), left = ref.left, top = ref.top, width = ref.width, height = ref.height;
            var mouseX = event.clientX - left;
            var mouseY = event.clientY - top;
            var percentX = (mouseX / width - 0.5) * 100;
            var percentY = (mouseY / height - 0.5) * 100;
            x.set(percentX);
            y.set(percentY);
        }
    };
    var handleMouseEnter = function() {
        setIsHovered(true);
    };
    var handleMouseLeave = function() {
        setIsHovered(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        className: "hover-effect-container",
        ref: containerRef,
        onMouseMove: handleMouseMove,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        style: {
            perspective: "1000px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                className: "hover-effect-content",
                style: {
                    rotateX: rotateX,
                    rotateY: rotateY,
                    transformStyle: "preserve-3d",
                    transition: "all 0.3s ease"
                },
                initial: {
                    rotateX: 0,
                    rotateY: 0
                },
                animate: {
                    rotateX: "".concat(rotateX, "deg"),
                    rotateY: "".concat(rotateY, "deg")
                },
                exit: {
                    rotateX: 0,
                    rotateY: 0
                },
                children: children
            }, "content")
        })
    });
};
/* harmony default export */ var hover_effect = (HoverEffect);

;// CONCATENATED MODULE: ./components/features-three-columns.jsx




function FeaturesThreeColumns(param) {
    var features = param.features, title = param.title, description = param.description, featureListTitleCss = param.featureListTitleCss, featureListCss = param.featureListCss, featureTitleCss = param.featureTitleCss, featureContentCss = param.featureContentCss, featureCss = param.featureCss, titleTag = param.titleTag;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (title || description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(section_title/* default */.Z, {
                title: title,
                description: description,
                className: "w-full mt-10 section-title ".concat(featureListTitleCss)
            }, "f-section-title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid gap-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 px-10 md:mt-10",
                children: features.map(function(f) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            featureCss && featureCss.includes("box") && /*#__PURE__*/ (0,jsx_runtime.jsx)(hover_effect, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
                                    feature: f,
                                    featureCss: featureCss,
                                    featureTitleCss: featureTitleCss,
                                    featureContentCss: featureContentCss,
                                    titleTag: titleTag
                                })
                            }, "anim-feat-".concat(f.id)),
                            (!featureCss || featureCss && !featureCss.includes("box")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
                                feature: f,
                                featureCss: featureCss,
                                featureTitleCss: featureTitleCss,
                                featureContentCss: featureContentCss,
                                titleTag: titleTag
                            }, "feat-".concat(f.id))
                        ]
                    });
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/features-four-columns.jsx



function FeaturesFourColumns(param) {
    var features = param.features, title = param.title, description = param.description, featureTitleCss = param.featureTitleCss, featureContentCss = param.featureContentCss, featureCss = param.featureCss, titleTag = param.titleTag;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (title || description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(section_title/* default */.Z, {
                title: title,
                description: description,
                className: "w-full mt-10 section-title"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid gap-10 grid-cols-1 md:grid-cols-4 px-10 md:mt-10",
                children: features.map(function(f) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
                        feature: f,
                        featureCss: featureCss,
                        featureTitleCss: featureTitleCss,
                        featureContentCss: featureContentCss,
                        titleTag: titleTag
                    }, f.id);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-accessible-accordion/dist/es/index.js
var es = __webpack_require__(1876);
;// CONCATENATED MODULE: ./components/features-accordion.jsx




function FeaturesAccordion(param) {
    var features = param.features, title = param.title, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col my-10 ",
        children: [
            (title || description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(section_title/* default */.Z, {
                title: title,
                description: description,
                className: "w-full"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full mt-10 px-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Accordion */.UQ, {
                    allowZeroExpanded: true,
                    preExpanded: [
                        "uuid-".concat(features[0].id.toString())
                    ],
                    children: features.map(function(f) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                            uuid: "uuid-".concat(f.id.toString()),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* AccordionItemButton */.on, {
                                        children: [
                                            f.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "flex flaticon-".concat(f.icon.icon, " text-").concat(f.icon.style, " text-6xl ")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "font-normal text-base inline-block",
                                                children: f.title
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* AccordionItemPanel */.Mt, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "block mb-4",
                                        dangerouslySetInnerHTML: {
                                            __html: f.content
                                        }
                                    })
                                })
                            ]
                        }, "acc-item-".concat(f.id.toString()));
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
;// CONCATENATED MODULE: ./components/features-animated.jsx






var FeaturesAnimated = function(param) {
    var features = param.features, title = param.title, description = param.description, featureListTitleCss = param.featureListTitleCss, featureTitleCss = param.featureTitleCss, featureContentCss = param.featureContentCss, featureCss = param.featureCss, titleTag = param.titleTag;
    var ref = (0,react.useState)(null), hoveredIndex = ref[0], setHoveredIndex = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (title || description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(section_title/* default */.Z, {
                title: title,
                description: description,
                className: "w-full section-title ".concat(featureListTitleCss)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid-animated px-4 xl:px-0 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-".concat(features.length > 3 ? 3 : features.length),
                children: features.map(function(f, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative group block p-8 h-full w-full",
                        onMouseEnter: function() {
                            return setHoveredIndex(idx);
                        },
                        onMouseLeave: function() {
                            return setHoveredIndex(null);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                children: hoveredIndex === idx && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                                    className: "absolute inset-0 h-full w-full bg-white bg-opacity-5 block rounded-3xl",
                                    layoutId: "hoverBackground",
                                    initial: {
                                        opacity: 0
                                    },
                                    animate: {
                                        opacity: 1,
                                        transition: {
                                            duration: 0.15
                                        }
                                    },
                                    exit: {
                                        opacity: 0,
                                        transition: {
                                            duration: 0.15,
                                            delay: 0.2
                                        }
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature, {
                                feature: f,
                                featureCss: featureCss,
                                featureTitleCss: featureTitleCss,
                                featureContentCss: featureContentCss,
                                titleTag: titleTag
                            }, f.id)
                        ]
                    }, "f-".concat(idx, "-").concat(f.id));
                })
            })
        ]
    });
};
/* harmony default export */ var features_animated = (FeaturesAnimated);

;// CONCATENATED MODULE: ./components/features.jsx










function Features(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "features-box ".concat(props.featureListCss ? props.featureListCss : ""),
        children: [
            props.featureListCss === "bg-net" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "skew-top"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "features-box-wrapper",
                children: [
                    props.style === "animated" && /*#__PURE__*/ (0,jsx_runtime.jsx)(features_animated, (0,_object_spread/* default */.Z)({}, props)),
                    props.style === "grid" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesGrid, (0,_object_spread/* default */.Z)({}, props)),
                    props.style === "grid-light" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesGridLight, (0,_object_spread/* default */.Z)({}, props)),
                    props.style === "one-column" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesOneColumn, (0,_object_spread/* default */.Z)({}, props)),
                    props.style === "two-columns" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesTwoColumns, (0,_object_spread/* default */.Z)({}, props)),
                    props.style === "three-columns" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesThreeColumns, (0,_object_spread/* default */.Z)({}, props)),
                    props.style === "four-columns" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesFourColumns, (0,_object_spread/* default */.Z)({}, props)),
                    props.style === "accordion" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesAccordion, (0,_object_spread/* default */.Z)({}, props))
                ]
            })
        ]
    });
}


/***/ }),

/***/ 5715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function SectionTitle(param) {
    var title = param.title, description = param.description, style = param.style, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat(className, " flex flex-col px-10 relative z-20  section-title"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row section-title-wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "".concat(style ? style : "", " flaticon-down-arrow text-5xl opacity-50 flex mr-2")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "".concat(style ? style : "", " mr-2 uppercase"),
                        dangerouslySetInnerHTML: {
                            __html: title
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "full mt-2 text-normal",
                dangerouslySetInnerHTML: {
                    __html: description
                }
            })
        ]
    });
}


/***/ }),

/***/ 4994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$U": function() { return /* binding */ Merge; }
/* harmony export */ });
/* unused harmony exports estimateTime, formatDate, uniqueArray, sortObjectByKey, getFirstLastName, replaceValuesInString, setEmailVars, nextGivenDay */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2222);



function Merge(glob, page) {
    var newObj = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, glob);
    for(var key in page){
        if (typeof page[key] === "object") {
            if (key === "metaImage") {
                if (page[key].data !== null) {
                    newObj[key] = page[key];
                }
            } else if (key === "metaSocial") {
                if (page[key].length > 0) {
                    newObj[key] = page[key];
                }
            } else {
                newObj[key] = page[key];
            }
        } else if ((0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(page[key]) === "array") {
            if (page[key].length) {
                newObj[key] = page[key];
            }
        } else {
            if (page[key]) {
                newObj[key] = page[key];
            }
        }
    }
    return newObj;
}
var estimateTime = function(content) {
    var text = content.replace(/(<([^>]+)>)/gi, "");
    var words = text.split(" ");
    return Math.ceil(words.length / 200);
};
var formatDate = function(date) {
    var newDate = new Date(date);
    return newDate.toLocaleDateString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric"
    });
};
var uniqueArray = function(arrayData) {
    return arrayData.filter(function(value, index, self) {
        return self.indexOf(value) === index;
    });
};
var sortObjectByKey = function(list, key) {
    var subKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, order = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "asc";
    if (subKey) {
        if (order === "asc") {
            return list.sort(function(a, b) {
                return a[key][subKey] > b[key][subKey] ? 1 : b[key][subKey] > a[key][subKey] ? -1 : 0;
            });
        } else {
            return list.sort(function(a, b) {
                return a[key][subKey] < b[key][subKey] ? 1 : b[key][subKey] < a[key][subKey] ? -1 : 0;
            });
        }
    } else {
        if (order === "asc") {
            return list.sort(function(a, b) {
                return a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0;
            });
        } else {
            return list.sort(function(a, b) {
                return a[key] < b[key] ? 1 : b[key] < a[key] ? -1 : 0;
            });
        }
    }
};
var getFirstLastName = function() {
    var fullName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var name = fullName.trim();
    if (!name.length) {
        return {
            firstname: "",
            lastname: ""
        };
    }
    var splitName = name.split(" ");
    var firstName = splitName[0];
    var lastName = splitName.length > 1 ? splitName[splitName.length - 1] : "";
    return {
        firstname: firstName,
        lastname: lastName
    };
};
var defaultReplaceMap = {
    "[[[": "{{{",
    "]]]": "}}}",
    "[[": "{{",
    "]]": "}}"
};
var replaceValuesInString = function(str) {
    var replaceMap = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultReplaceMap;
    var pattern, replacer;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(replaceMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _sliced_to_array(_step.value, 2), key = _value[0], value = _value[1];
            pattern = new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g");
            replacer = value;
            str = str.replace(pattern, replacer);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return str;
};
var setEmailVars = function(text) {
    return text.replace(/\[\[\[/g, "{{{").replace(/\]\]\]/g, "}}}").replace(/\[\[/g, "{{").replace(/\]\]/g, "}}");
};
var nextGivenDay = function(day, hour) {
    var toISO = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    var today = new Date();
    var targetDay = today.getDay();
    while(daysOfWeek[targetDay] !== day){
        targetDay = (targetDay + 1) % 7;
    }
    var nextDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (targetDay + 7 - today.getDay()) % 7);
    nextDate.setHours(hour);
    if (nextDate <= today) {
        nextDate.setDate(nextDate.getDate() + 7);
    }
    if (toISO) {
        return nextDate.toISOString();
    } else {
        nextDate;
    }
};


/***/ })

}]);